import api from './../../api/api'

export default {

  roles: async (page, take, sortBy, sortOrder, search, filters) => {
    return api.get(`api/roles?page=${page}&take=${take}&sort_by=${sortBy}&sort_order=${sortOrder}&search=${search}&filters=${filters}`)
  },

  create: async role => {
    return api.post('api/roles', role)
  },

  get: async id => {
    return api.get('api/roles/' + id)
  },

  update: async (id, role) => {
    return api.put('api/roles/' + id, role)
  },

  delete: async id => {
    return api.delete('api/roles/' + id)
  }
}
